import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Subscription } from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-pga-zorg',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-pga-zorg.component.html',
  styleUrl: './tekst-pga-zorg.component.scss',
})
export class TekstPgaZorgComponent implements OnInit, OnDestroy {
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;

  @Input() public id!: string;
  public ibAangifte = {} as Aangifte;
  public focusedElementId: string | null = null;
  public year = 2024;
  public actualYear: number = new Date().getFullYear();

  public kmPrijs = 0;

  constructor(
      public dataService: BokkzIbDataService) {
  }

  ngOnInit(): void {
    this.incomeTaxEntitySubscription= this.dataService.incomeTaxEntity.subscribe((value) => {
      if (value.year !== undefined) {
        this.year = value.year;
      }
      if (this.year == 2024 || this.year == 2025 || this.year == 2026) {
        this.kmPrijs = 23
      }
    })
  }

  ngOnDestroy(): void {
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

}
